import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { Row, Form, Col, Button, Card } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import {
  InputControl,
  InputValidationConstants,
  SubmitButtonContent,
  TextAreaControl,
  SelectControl,
  TinymceControl,
  createOptionsFromEnum,
  DateTimeControl,
  NumberControl,
  CheckboxControl,
  DataTable,
  GridButton,
  InputTypeConstants,
  SearchParamTypeConstants,
  getSearchField,
  getTableHeader,
} from "wup-module1-base";
import {
  RoutePathConstants,
  PageTypeEnum,
  AnswerTypeEnum,
} from "../../../../Constants";
import "../../../DragAndDrop.css";
import { v4 as uuidv4 } from "uuid";
import { QuestionList } from "../../..";
import {
  faPencil,
  faCircleCheck,
  faCircleXmark,
  faTrash,
  faObjectGroup,
  faUsersBetweenLines,
  faComments,
  faPlus,
  faMinus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PageQuestions from "./PageQuestions";

function PageForm({
  onSubmit,
  model = null,
  isEdit = false,
  isSubmitting = false,
}) {
  const navigate = useNavigate();
  const {
    register,
    trigger,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    control,
    formState: { errors, isValid },
  } = useForm({
    mode: "all",
  });
  const { append, update, remove, move, fields } = useFieldArray({
    control,
    name: "questions",
    keyName: "uuid",
  });
  const questionsRef = useRef();
  const groupsRef = useRef();

  function getActionButtons(value) {
    return (
      <>
        <GridButton
          id={"btnPage" + value.id}
          color={value.pageId === model.id ? "btn-danger" : "btn-success"}
          icon={value.pageId === model.id ? faMinus : faPlus}
          disabled={value.deleted}
          ariaLabel={
            value.pageId === model.id
              ? "Usunięcie pytania ze strony"
              : "Dodanie pytania do strony"
          }
          title={
            value.pageId === model.id ? "Usuń ze strony" : "Dodaj do strony"
          }
          onClick={() => handlePageBtn(value)}
        />

        <GridButton
          id={"btnEdit" + value.id}
          color="btn-primary"
          icon={faPencil}
          disabled={value.deleted}
          ariaLabel="Edycja pytania"
          title="Edycja pytania"
          onClick={() =>
            navigate(
              `/${RoutePathConstants.Question}/${RoutePathConstants.Edit}/${value.id}`
            )
          }
        />
      </>
    );
  }

  const getRowProps = (value) => ({
    className: value.deleted ? "row-deleted" : "",
  });

  function fetchQuestions() {
    return JSON.parse(sessionStorage.getItem("questions"));
  }

  const handlePageBtn = (value) => {
    value.pageId = value.pageId === model.id ? "" : model.id;
    const toUpdate = { ...value };
    const questions = JSON.parse(sessionStorage.getItem("questions"));
    const updated = questions.map((item) =>
      item.id === value.id ? toUpdate : item
    );
    sessionStorage.setItem("questions", JSON.stringify(updated));
    if (value.pageId === model.id)
      append({ ...value, order: fields.length + 1 });
    else {
      const questionIdx = fields.findIndex((i) => i.name === value.name);
      remove(questionIdx);
    }
    questionsRef?.current?.reloadData();
  };

  const renderRelated = (value) => {
    return value.relatedQuestions?.length > 0 ? (
      <FontAwesomeIcon
        icon={faCircleCheck}
        title="Tak"
        className="text-success"
        size="xl"
      />
    ) : (
      <FontAwesomeIcon
        icon={faCircleXmark}
        className="text-danger"
        title="Nie"
        size="xl"
      />
    );
  };

  const searchFields = [
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "name",
      "Nazwa",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_STRING,
      "description",
      "Opis",
      InputTypeConstants.string
    ),
    getSearchField(
      SearchParamTypeConstants.SEARCH_EQUAL,
      "deleted",
      "Pokaż usunięte",
      InputTypeConstants.checkbox
    ),
  ];

  const tableHeaders = [
    // getTableHeader("Id", "id", null, true, "w-15"),
    getTableHeader("Nazwa", "name", null, true, "w-15"),
    getTableHeader("Opis", "description", null, true, "w-auto"),
    getTableHeader(
      "Czy zawiera skorelowane",
      null,
      null,
      false,
      "w-10",
      renderRelated,
      "text-center"
    ),
    getTableHeader(
      null,
      null,
      "Akcje",
      false,
      "w-10",
      getActionButtons,
      "text-center"
    ),
  ];

  useEffect(() => {
    if (model !== null) {
      reset(model);
    }
  }, [model]);

  useEffect(() => {
    trigger();
  }, [trigger, fields]);

  const submitForm = (page) => {
    console.log(page);
    const modifiedData = getRequestData(page);
    onSubmit(modifiedData);
  };

  const getRequestData = (page) => {
    return {
      ...page,
      id: model.id,
      questions: getQuestionsWithUpdatedOrder(page),
    };
  };

  const getQuestionsWithUpdatedOrder = (page) => {
    return page.questions.map((obj, index) => {
      if ("newQuestion" in obj) {
        delete obj.newQuestion;
      }
      return { ...obj, order: index + 1, pageId: model.id };
    });
  };

  // useEffect(() => {
  //   document.addEventListener("focusin", function (e) {
  //     console.log("nowy3");
  //     e.stopImmediatePropagation();
  //     e.stopPropagation();
  //     e.preventDefault();

  //   });
  //   document.addEventListener("click", function (e) {
  //     console.log("nowy4");
  //     e.stopImmediatePropagation();
  //     e.stopPropagation();
  //     e.preventDefault();
  //   });
  // }, []);

  return (
    <>
      <Card>
        <Card.Header>Lista pytań</Card.Header>
        <Card.Body className="pt-4-5">
          <DataTable
            fetchData={fetchQuestions}
            headers={tableHeaders}
            searchFields={searchFields}
            rowProps={getRowProps}
            ref={questionsRef}
          >
            <Button
              variant="primary"
              onClick={() =>
                navigate(
                  `/${RoutePathConstants.Question}/${RoutePathConstants.Add}`
                )
              }
            >
              Dodaj pytanie
            </Button>
          </DataTable>
        </Card.Body>
      </Card>
      <Form onSubmit={handleSubmit(submitForm)}>
        <Row>
          <Col md={12}>
            <InputControl
              id={"name"}
              label={"Nazwa"}
              readOnly={false}
              refs={{
                ...register("name", {
                  required: InputValidationConstants.required,
                  maxLength: {
                    value: 100,
                    message: InputValidationConstants.maxLength.replace(
                      "{placeholder}",
                      100
                    ),
                  },
                }),
              }}
              errors={errors}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <TextAreaControl
              id={"description"}
              label={"Opis"}
              readOnly={false}
              rows={3}
              refs={{
                ...register("description", {
                  //required: InputValidationConstants.required,
                  maxLength: {
                    value: 512,
                    message: InputValidationConstants.maxLength.replace(
                      "{placeholder}",
                      512
                    ),
                  },
                }),
              }}
              errors={errors}
            />
          </Col>
        </Row>
        {model && (
          <Row>
            <Col md={12}>
              <PageQuestions
                register={register}
                fields={fields}
                move={move}
                remove={remove}
                append={append}
                update={update}
                getValues={getValues}
                pageId={model?.id}
                errors={errors}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col md={12}>
            <Button
              type="submit"
              variant="primary"
              disabled={!isValid || isSubmitting}
            >
              <SubmitButtonContent
                isSubmitting={isSubmitting}
                condition={isEdit}
              />
            </Button>
            <Button
              className="mx-2"
              type="button"
              variant="secondary"
              onClick={() => navigate(`/${RoutePathConstants.Page}`)}
            >
              Powrót
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  );
}

export default PageForm;
